





















































































import { Component, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect, mdbBtn, mdbIcon, mdbTooltip } from '@folky-tools/mdbvue';
import { usersService, userInvitationsService, projectsService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Invitation } from '@/models/users/user-invitations/invitation';
import { Project } from '../../models/projects/project';
import { Application } from '@/models/applications/application';
import { is_email_valid as isEmailValid } from 'node-email-validation';
import { required, email, minValue } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    },
    validations: {
        model: {
            projectId: { required, minValue: minValue(1) },
            email: {
                required,
                email,
                customEmail: async (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return isEmailValid(value);
                }
            },
            destinationApplicationId: { required, minValue: minValue(1) }
        }
    }
})
export default class NewUserInvitationView extends Vue {
    private model: Invitation = new Invitation();
    private projects: Project[] = [];
    private destinationApps: Application[] = [];
    private savingInvitation: boolean = false;
    private invitationSent: boolean = false;

    private async mounted(): Promise<void> {
        this.projects = await projectsService.getProjects();
        this.destinationApps = await userInvitationsService.getDestinationApplications();
        this.$root.$emit('change-active-page', 'views.users.newUserInvitationView.title');

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.UserInvitations,
                scope: UserActionScopeType.New
            })
        );
    }

    private onChangeProjectId(value: number, text: string): void {
        if (value) {
            const selectedProject = this.projects.find(p => p.id === value);
            this.model.projectId = selectedProject!.id;
        }
    }

    private onChangeDestinationApplicationId(value: number, text: string): void {
        if (value) {
            const selectedApplication = this.destinationApps.find(app => app.id === value);
            this.model.destinationApplicationId = selectedApplication!.id;
            this.model.destinationApplicationClientId = selectedApplication!.clientId;
            this.model.destinationApplicationName = selectedApplication!.text;
            this.model.destinationApplicationUri = selectedApplication!.clientUri;
        }
    }

    private async sendInvitation(): Promise<void> {
        this.savingInvitation = true;

        this.$v.model.$touch();
        if (this.$v.model.$error) {
            this.savingInvitation = false;
            return;
        }

        try {
            if (await userInvitationsService.newInvitation(this.model)) {
                this.invitationSent = true;

                notificationsService.showToastSuccessNotification('views.users.newUserInvitationView.actions.send.success.notification');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCreated,
                        entity: UserActionEntityType.UserInvitations,
                        scope: UserActionScopeType.New
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingInvitation = false;
        }
    }

    private newInvitation(): void {
        this.invitationSent = false;
        this.model.name = undefined;
        this.model.email = undefined;
        this.$v.model.$reset();
    }
}
